<template>
  <Edit :id="id" :is_instant="true" />
</template>

<script>
import fixHeightMain from "@/mixins/fixHeightMain.mixin";
import Edit from './Edit';

export default {
  props: ["id"],
  mixins: [fixHeightMain],
  components: {
    Edit
  },
  data: function() {
    return {
    }
  }
}
</script>

<style scoped="scoped">

</style>